export const ServiceInformations = {
  default: {
    name: 'Leadle',
    logo: '/static/images/logo_leadle.svg',
    logoBlue: '/static/images/logo_leadle_blue.svg',
    company: 'SalesX',
    copyright: 'SalesX Inc. 2025',
    title: 'リードマーケティングツール「リードル」',
    operatingCompanyUrl: 'https://salesx.co.jp/',
    isCorporationPage: false,
    termOfServiceLink: 'internal',
  },
  kobot: {
    name: 'HRコボット for 営業リスト',
    logo: '/static/images/logo_kobot.svg',
    logoBlue: '/static/images/logo_kobot_blue.svg',
    company: 'DIP',
    copyright: 'DIP Corporation 2020',
    title: 'HRコボット for 営業リスト｜コボット RPA/DXサービス',
    operatingCompanyUrl: 'https://www.dip-net.co.jp',
    isCorporationPage: true,
    termOfServiceLink: 'external',
    // TODO リンクを決める
    externalTermUrl: 'https://www.dip-net.co.jp/service/terms',
    identifier: 'kobot',
  },
  mynavi: {
    name: 'マイナビ転職PGP',
    logo: '/static/images/logo_mynavi.png',
    logoBlue: '/static/images/logo_mynavi_blue.png',
    company: '株式会社マイナビ',
    copyright: 'Mynavi Corporation 2025',
    title: 'マイナビ転職PGP',
    operatingCompanyUrl: 'https://www.mynavi.jp/company/',
    isCorporationPage: true,
    termOfServiceLink: 'internal',
    // TODO リンクを決める
    identifier: 'mynavi',
  },
}

export default {
  methods: {
    serviceInformation () {
      const domain = location.hostname.split('.')[0]
      let information = ServiceInformations[domain]
      if (information === undefined || information === null) {
        information = ServiceInformations.default
      }
      return information
    },
    pageTitle () {
      return this.serviceInformation().title
    },
    siteLogo () {
      return this.serviceInformation().logo
    },
    siteLogoBlue () {
      return this.serviceInformation().logoBlue
    },
    siteName () {
      return this.serviceInformation().name
    },
    copyright () {
      return this.serviceInformation().copyright
    },
    operatingCompanyUrl () {
      return this.serviceInformation().operatingCompanyUrl
    },
    isCorporationPage () {
      return this.serviceInformation().isCorporationPage
    },
    isInternalTermOfServiceLink () {
      return this.serviceInformation().termOfServiceLink === 'internal'
    },
    externalTermUrl () {
      return this.serviceInformation().externalTermUrl
    },
    identifier () {
      return this.serviceInformation().identifier
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixin/service_information.js